"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewableTechnology = exports.PixelType = void 0;
const AmpPixel = __importStar(require("./amp-pixel"));
const IntersectionPixel = __importStar(require("./intersection-pixel"));
const MousePixel = __importStar(require("./mouse-pixel"));
const MozPaintCountPixel = __importStar(require("./mozpaintcount-pixel"));
const MraidPixel = __importStar(require("./mraid-pixel"));
const SafeFramePixel = __importStar(require("./safeframe-pixel"));
var PixelType;
(function (PixelType) {
    PixelType[PixelType["None"] = 0] = "None";
    PixelType[PixelType["Flash"] = 1] = "Flash";
    PixelType[PixelType["MozPaintCount"] = 2] = "MozPaintCount";
    PixelType[PixelType["Geometric"] = 3] = "Geometric";
    PixelType[PixelType["SafeFrame"] = 4] = "SafeFrame";
    PixelType[PixelType["Mraid"] = 5] = "Mraid";
    PixelType[PixelType["Mouse"] = 6] = "Mouse";
    PixelType[PixelType["Amp"] = 7] = "Amp";
    PixelType[PixelType["Intersection"] = 8] = "Intersection";
    PixelType[PixelType["Omid"] = 9] = "Omid";
})(PixelType = exports.PixelType || (exports.PixelType = {}));
let viewableTechnology_ = null;
function getViewableTechnology() {
    const getViewableTechnology_ = () => {
        if (MraidPixel.isAvailable()) {
            return PixelType.Mraid;
        }
        else if (AmpPixel.isAvailable()) {
            return PixelType.Amp;
        }
        else if (IntersectionPixel.isAvailable()) {
            return PixelType.Intersection;
        }
        else if (SafeFramePixel.isAvailable()) {
            return PixelType.SafeFrame;
        }
        else if (typeof window !== 'undefined' && (window['inDapIF'] === true || window === window.top)) {
            return PixelType.Geometric;
        }
        else if (MozPaintCountPixel.isAvailable()) {
            return PixelType.MozPaintCount;
        }
        else if (MousePixel.isAvailable()) {
            return PixelType.Mouse;
        }
        else {
            return PixelType.None;
        }
    };
    if (viewableTechnology_ === null) {
        viewableTechnology_ = getViewableTechnology_();
    }
    return viewableTechnology_;
}
exports.getViewableTechnology = getViewableTechnology;
//# sourceMappingURL=index.js.map